// All konfigurasjon kommer fra miljøvariabler, slik at samme bygg kan peke mot
// testmiljøet og produksjon. Vite bakes verdiene inn ved build - de er derfor
// offentlige, og her skal det ALDRI ligge en client secret. Launcheren er en
// public client med PKCE nettopp fordi den ikke kan holde på en hemmelighet.

function paakrevd(navn: string): string {
  const verdi = import.meta.env[navn] as string | undefined;
  if (!verdi) {
    throw new Error(
      `Mangler miljøvariabelen ${navn}. Kopier .env.example til .env og fyll inn.`,
    );
  }
  return verdi;
}

function url(navn: string): string {
  // Uten trailing slash, så vi kan sette den sammen forutsigbart senere.
  return paakrevd(navn).replace(/\/+$/, "");
}

export const config = {
  idpUrl: url("VITE_IDP_URL"),
  realm: paakrevd("VITE_REALM"),
  clientId: paakrevd("VITE_CLIENT_ID"),

  apper: {
    reports: url("VITE_REPORTS_URL"),
    companion: url("VITE_COMPANION_URL"),
    cabinet: url("VITE_CABINET_URL"),
    contracts: url("VITE_CONTRACTS_URL"),
  },
} as const;

/** Realmens issuer - grunnlaget for discovery, og det `iss` skal matche. */
export const issuer = `${config.idpUrl}/realms/${config.realm}`;

/**
 * Keycloaks account console. Her styrer brukeren selv passord og MFA, så vi
 * slipper å bygge noe av det i launcheren.
 */
export const kontoUrl = `${issuer}/account/`;
